import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

// Mirrors the real row height and the number of prize lines the pot holds, so the table does not
// jump when the data arrives and the wait does not read as a broken screen.

const PLACEHOLDER_ROWS = 11;

export default function LcvPrizePotGridSkeleton() {
     return (
          <Box>
               {Array.from({ length: PLACEHOLDER_ROWS }).map((unused, index) => (
                    <Box
                         key={index}
                         sx={{
                              display: "flex",
                              gap: 2,
                              py: 1.5,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                         }}
                    >
                         <Skeleton variant="text" width="30%" />
                         <Skeleton variant="text" width="10%" />
                         <Skeleton variant="text" width="8%" />
                         <Skeleton variant="text" width="8%" />
                         <Skeleton variant="text" width="8%" />
                         <Skeleton variant="text" width="12%" />
                         <Skeleton variant="text" width="14%" />
                    </Box>
               ))}
          </Box>
     );
}
